const BRAND = "Gitcha";
const DEFAULT_TITLE = "Gitcha: Buyer Demand from Local Real Estate Agents";
const MAX_DESCRIPTION = 160;

const truncate = (text, max = MAX_DESCRIPTION) => {
  const value = String(text || "").replace(/\s+/g, " ").trim();
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1).trimEnd()}…`;
};

// Rental want-listings share this page, so the consumer label follows adType.
// Anything unrecognised (e.g. land variants) stays neutral rather than guessing.
const consumerLabel = (adType) => {
  if (adType === "BUY") return "Buyer";
  if (adType === "LTR" || adType === "STR") return "Renter";
  return "";
};

const buildDescription = (adDetails) => {
  const desc = adDetails && adDetails.adDesc ? String(adDetails.adDesc).trim() : "";
  if (desc) return truncate(desc);
  const consumer = consumerLabel(adDetails && adDetails.adType);
  const listing = consumer ? `${consumer} Want-Listing` : "Want-Listing";
  const title = adDetails && adDetails.adTitle ? adDetails.adTitle : listing;
  return truncate(
    `${title}. A ${listing} from a local real estate agent on ${BRAND}.`,
  );
};

export const buildWantAdSeo = (adDetails, { origin = "", pathname = "" } = {}) => {
  const indexable = Boolean(adDetails && adDetails.syndicateToThePublic);
  const title =
    adDetails && adDetails.adTitle ? `${adDetails.adTitle} | ${BRAND}` : DEFAULT_TITLE;
  const description = buildDescription(adDetails);
  const canonical = origin ? `${origin}${pathname || ""}` : "";
  const loaded = Boolean(adDetails);

  return {
    indexable,
    title,
    description,
    canonical,
    robots: loaded ? (indexable ? "index,follow" : "noindex,nofollow") : null,
    ogImage: origin ? `${origin}/logo512.png` : "",
  };
};

export default buildWantAdSeo;
